<div
  class="-mb-5 flex items-center gap-4 rounded-t-lg border-t-2 border-r-2 border-l-2 px-4 py-2 pb-8 select-none"
  [class]="variant() === 'INFO' ? 'border-blue-500 bg-blue-100' : 'border-emerald-500 bg-emerald-100'"
>
  @if (variant() === 'INFO') {
    <i-checkbox class="size-8 text-blue-500" />
  } @else {
    <i-thumb class="size-8 text-emerald-500" />
  }

  <p class="font-default flex grow gap-1">
    <span class="font-bold">{{ title() }}</span>
    <span>{{ description() }}</span>
  </p>

  <rid-button content="Volgende" size="SMALL" [appearance]="variant() === 'INFO' ? 'NEUTRAL' : 'SUCCESS'" />
</div>
